import api from 'api/apiInstance';

export function clientSummaryInteractionReportApi(path: string) {
  return {
    path,
    DELETE: () => api.delete(path),
  };
}
